module.exports = new __parcel__URL__("create-articles.766910dd.svg").toString();